import React from 'react';
import { RadioGroup } from '@mui/material';
import { Radio } from '@src/design-system/radio-button/Radio';
import { FormControlLabel } from 'design-system';
import { useProductLines } from '@src/shared/hooks/useProductLines';

type ProductLineFilterProps = {
  value: string;
  onChange: (value: string) => void;
};

export const ProductLineFilter: React.FC<ProductLineFilterProps> = ({
  value,
  onChange,
}) => {
  const { productLineOptions, loading } = useProductLines();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  if (loading) {
    return null;
  }

  return (
    <RadioGroup row value={value} onChange={handleChange}>
      <FormControlLabel value="all" control={<Radio />} label="All" />
      {productLineOptions.map((option) => (
        <FormControlLabel
          key={option.value}
          value={option.value}
          control={<Radio />}
          label={option.label}
        />
      ))}
    </RadioGroup>
  );
};
